import { routeTree } from "@/routeTree.gen";
import { createRouter } from "@tanstack/react-router";
import { queryClient } from "../react-query";

// Set up a Router instance
export const router = createRouter({
	routeTree,
	defaultPreload: "intent",
	context: {
		queryClient,
		auth: {
			isAuthenticated: false,
			user: null,
			// biome-ignore lint/suspicious/noEmptyBlockStatements: <explanation>
			setUser: () => {},
		},
	},
});

// Register things for typesafety
declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}
